<template>
    <svg width="20" height="20" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="-0.0555113" y="1.05922" width="7.22665" height="11.3607" rx="1.96276" transform="matrix(0.669122 0.743153 -0.743137 0.66914 13.427 2.39171)" stroke="currentColor" stroke-width="1.5"/>
        <path d="M19.8161 20.1515C20.1036 20.4497 20.5784 20.4584 20.8766 20.171C21.1748 19.8835 21.1835 19.4087 20.896 19.1105L20.356 19.631L19.8161 20.1515ZM13 12L12.46 12.5205L19.8161 20.1515L20.356 19.631L20.896 19.1105L13.54 11.4795L13 12Z" fill="currentColor"/>
        <path d="M4.45801 20H15.3089" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    </svg>
</template>
